import gql from 'graphql-tag';

export const checkUserExist = gql`
  query checkUserExist {
    checkUserExist {
      existing
      success
      contactId
      consentGivenAt
    }
  }
`;
